import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-644e9dc9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "viewer-wrapper" }
const _hoisted_2 = { class: "card mt-3 mb-3" }
const _hoisted_3 = { class: "card-header" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = ["src", "data-source", "alt"]
const _hoisted_6 = {
  key: 0,
  class: "card-footer"
}


import { component as viewer } from "v-viewer";
import "viewerjs/dist/viewer.css";


export default /*#__PURE__*/_defineComponent({
  name: 'screenshots-grid.component',
  props: ["images"],
  setup(__props) {

const props = __props



const options = {
  inline: false,
  button: true,
  navbar: true,
  title: true,
  toolbar: true,
  tooltip: false,
  movable: false,
  zoomable: false,
  rotatable: false,
  scalable: false,
  transition: true,
  fullscreen: true,
  keyboard: true,
  url: "data-source",
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(viewer), {
      options: options,
      images: __props.images,
      rebuild: "",
      class: "row viewer"
    }, {
      default: _withCtx((scope) => [
        _renderSlot(_ctx.$slots, "default"),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.images, ({ source, thumbnail, title, link }) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-sm-6 col-md-4 col-lg-3",
            key: source
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(title), 1),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("img", {
                  class: "image",
                  src: thumbnail,
                  "data-source": source,
                  alt: title
                }, null, 8, _hoisted_5)
              ]),
              (link != undefined)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(_component_router_link, {
                      to: {
                    name: link.name,
                    params: link.params,
                  }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(link.text), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        }), 128))
      ]),
      _: 3
    }, 8, ["images"])
  ]))
}
}

})